import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export type LocationType = '' | 'start' | 'arrival' | 'via';
export type LocationTypeViewModel = {
  locationId: string;
  locationType: LocationType;
};

@Component({
  selector: 'app-shipment-route-map-popup',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, CommonModule],
  templateUrl: './shipment-route-map-popup.component.html',
  styleUrl: './shipment-route-map-popup.component.scss',
})
export class ShipmentRouteMapPopupComponent {
  /** 場所の種類 */
  @Input() public locationType: LocationType = '';

  /** 位置情報ID */
  @Input() public locationId: string = '';

  /** 位置情報名 */
  @Input() public locationName: string = '';

  /** ジオフェンステキスト */
  @Input() public geofenceText: string = '';

  /** 住所 */
  @Input() public address: string = '';

  /** ボタンを表示させるか */
  @Input() public displayButtonOnPopup: boolean = false;

  /** 経由地フォーム数 */
  @Input() public numberOfViaLocationForm: number = 1;

  /** 押されたボタンの位置情報タイプ */
  @Output() locationTypeButtonClicked =
    new EventEmitter<LocationTypeViewModel>();
}
